import type { FaireProductEntity } from "../../entity_types/product";

export const p_za8fjdjcn7: FaireProductEntity = {
  token: "p_za8fjdjcn7",
  type: "product",
  name: "Lavender Lemon Chill - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/3b351e3a84bbdefb93eb8426f321420bf61a303b68a316b48fcc71ef2a7f2f46.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d793f28337c4d207a991c09553ab7961d042c6f48e56da72be58ed0a5708805d.jpeg"
  ],
  priceDollars: 9.8,
  description: "\n\nSUPERFOOD TEA BLEND \n\nThis luxurious lavender tea channels sweet sunshine and frolics in a French lavender field. Stress-busting lavender mingles with juicy lemon myrtle, lemon peel and green rooibos for a caffeine-free sip that's delicious hot or iced. \n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED \n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Try me with a splash of milk and honey. \n * Tea Latte: Steep tea double strength and top with frothed milk, vanilla and sweetener. \n * Ice it: Steep it double strength and top with plenty of ice. \n * Cold-brew: Brew it overnight with cold water and added citrus. \n * Make a tea cocktail: steep it double strength and top with sparkling water \nWhen to Steep:\n\n\n * During your slow morning ritual. \n * Mid-day to slow down and sip in mindfulness. \n * As an iced tea to hydrate midday. \n * After dinner to wind down and ease digestion. \n * At a summer garden party, a picnic, on the beach, or with brunch \n * Before bed to promote sleep. \n\nCaffeine-free\n\n\n\n",
  tags: [],
  msrpDollars: 15.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:46.674Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
